import React from "react";
import { Badge } from "@/components/ui/badge";
import { StepIndicator } from "@/components/ui/step-indicator";
import { Clock } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface Step {
  id: string;
  title: string;
  href: string;
  status: "completed" | "current" | "upcoming";
}

interface ProfileStepsLayoutProps {
  currentStep: number;
  totalSteps: number;
  title: string;
  description: string;
  estimatedTime: string;
  steps: Step[];
  children: React.ReactNode;
}

export function ProfileStepsLayout({
  currentStep,
  totalSteps,
  title,
  description,
  estimatedTime,
  steps,
  children
}: ProfileStepsLayoutProps) {
  const { t } = useTranslation(["talent", "common"]);

  return (
    <div className="space-y-6">
      {/* Step Indicator */}
      <StepIndicator currentStep={currentStep} steps={steps} className="mb-6" />

      {/* Page Header */}
      <div className="mb-6">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-3">
            <h1 className="text-2xl font-bold">{title}</h1>
            <Badge variant="secondary">
              {t("talent:application.step_number", {
                current: currentStep,
                total: totalSteps
              })}
            </Badge>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <Clock className="h-4 w-4" />
            {t("talent:application.estimated_duration", {
              time: estimatedTime
            })}
          </div>
        </div>
        <p className="text-gray-600">{description}</p>
      </div>

      {children}
    </div>
  );
}
